<template>
  <props-holder
    :shelf-config="shelfConfig"
    :shelf-index="shelfIndex"
    :props-list="propsList"
    :placeholder-goods="placeholderGoods"
    :game-coin-icon="currentItem.gameCoinIcon"
    :game-coin-unit="currentItem.unit"
    :no-goods-tips="noGoodsTips"
    :is-loading="isLoading"
    :go-to-prop-page="goToPropPage"
  ></props-holder>
</template>

<script>
import propsHolder from "./propsHolder.vue"
import { mapGetters, mapActions } from "vuex"
import gameServiceZoneMixin from "../../mixins/gameServiceZone"
import gameListShelfMixin from "../../mixins/gameListShelf"
import * as reportDict from "@constants/report-dictonary"
import * as gameProps from "@api/gameProps"
import Raven from "raven-js"
import * as url from "@utils/url"

export default {
  components: {
    "props-holder": propsHolder
  },
  mixins: [gameServiceZoneMixin, gameListShelfMixin],
  props: {
    shelfConfig: Object,
    shelfIndex: Number
  },
  computed: {
    ...mapGetters(["vmallConfigByAMSID", "vmallGoodsList", "vmallConfigByItemID"]),
    isHotTag() {
      // 热销是否展示前十tab
      return this.shelfConfig && this.shelfConfig.recommConfig && this.shelfConfig.recommConfig.isHotTag
    }
  },
  watch: {
    currentItemKey() {
      this.initList()
    }
  },
  created() {
    this.initList()
  },
  methods: {
    ...mapActions(["reportUserAction", "getRecommendDispatcher"]),
    initList() {
      this.getRecommendDispatcher({
        modelId: this.shelfConfig.recommConfig.modelId,
        byNode: this.shelfConfig.recommConfig?.byNode || false,
        recommConfig: {
          activityId: this.shelfConfig.recommConfig?.activity_id || ""
        },
        service: this.shelfConfig.recommConfig?.service || "",
        keyName: url.getParam("tx_seller_id"),
        pageSize: this.shelfConfig.recommConfig?.pageSize || undefined
      })
        .then(recommInfo => {
          // 取到道具数据后需要将占位数据清空，这样当道具为空时会显示【道具更新中】
          this.placeholderGoods = []
          let goodsList = []
          let sortArr = Object.keys(recommInfo).sort((a, b) => {
            return parseInt(a) < parseInt(b) ? -1 : 1
          })
          let topNum = 0
          sortArr.forEach(key => {
            if (recommInfo[key] && this.getPropByGoodId(this.currentItem?.busId, recommInfo[key])) {
              let props = this.getPropByGoodId(this.currentItem?.busId, recommInfo[key])
              if (gameProps.checkPropCanBuy(props)) {
                if (this.isHotTag && topNum < 10) {
                  goodsList.push({
                    ...props,
                    hotTag: "热销排名",
                    hotIndex: topNum + 1
                  })
                  topNum++
                } else {
                  goodsList.push(props)
                }
              }
            }
          })
          this.propsList = goodsList
        })
        .catch(e => {
          // 请求失败，默认展示
          this.propsList = gameProps.getDefaultOrderProps({
            vmallGoodsList: this.vmallGoodsList,
            busId: this.currentItem && this.currentItem.busId
          })

          Raven.captureException(new Error("getHotListRecomm error"), {
            tags: { type: "getHotListRecomm-error" },
            extra: { e }
          })
        })
      this.reportUserAction({
        iformat: `${reportDict.PAGE_VIEW.SERVICEZONE_HOT}`,
        pfStructure: this.$route.query.pfStructure
      })
    },
    // 前往道具详情页
    goToPropPage(prop, index) {
      this.goToPropDetail({
        prop: prop,
        pfStructure: `${this.shelfConfig.keyName}_${index + 1}`,
        reportIformat: reportDict.CLICK.SERVICEZONE_HOT_GOODS_LIST,
        routeQuery: {
          isFromShop: 1
        }
      })
    }
  }
}
</script>
